export type SelectObject = {
  id: number | string;
  name: string;
};

export interface SelectList {
  [key: string]: SelectObject[];
}

const selectsLists: SelectList = {
  engineTypes: [
    {
      id: 1,
      name: "CFM56",
    },
    {
      id: 2,
      name: "V2500",
    },
    {
      id: 3,
      name: "RB211",
    },
    {
      id: 4,
      name: "PW1100",
    },
    {
      id: 5,
      name: "CFM565B",
    },
    {
      id: 6,
      name: "CFM567B",
    },
  ],
  inspectionPhases: [
    {
      id: 1,
      name: "Inspección desmontaje",
    },
    {
      id: 2,
      name: "Inspección MdP",
    },
    {
      id: 3,
      name: "Reparación MdP",
    },
    {
      id: 4,
      name: "Inspección CC",
    },
  ],
};

export const COLOURS_STRING: string[] = [
  "Amarillo",
  "Azul",
  "Blanco",
  "Granate",
  "Gris",
  "Naranja",
  "Negro",
  "Rojo",
  "Rosa",
  "Turquesa",
  "Verde",
];

export const ENGINE_TYPES = [
  {
    value: "1",
    label: "CFM56",
  },
  {
    value: "2",
    label: "V2500",
  },
  {
    value: "3",
    label: "RB211",
  },
  {
    value: "4",
    label: "PW1100",
  },
];

export const INSPECTION_PHASES = [
  {
    id: 1,
    name: "Inspección desmontaje",
  },
  {
    id: 2,
    name: "Inspección MdP",
  },
  {
    id: 3,
    name: "Reparación MdP",
  },
  {
    id: 4,
    name: "Inspección CC",
  },
];

export const PHASES_LIST = [
  {
    id: 1,
    name: "disassemblyInspection",
  },
  {
    id: 2,
    name: "mdpInspection",
  },
  {
    id: 3,
    name: "mdpRepair",
  },
  {
    id: 4,
    name: "ccInspection",
  },
];

export const INSPECTION_PHASES_VALUES = [
  {
    value: "1",
    label: "Inspección desmontaje",
  },
  {
    value: "2",
    label: "Inspección MdP",
  },
  {
    value: "3",
    label: "Reparación MdP",
  },
  {
    value: "4",
    label: "Inspección CC",
  },
];

export const ENGINE_COLOURS = [
  {
    value: "1",
    label: "Amarillo",
  },
  {
    value: "2",
    label: "Azul",
  },
  {
    value: "3",
    label: "Blanco",
  },
  {
    value: "4",
    label: "Granate",
  },
  {
    value: "5",
    label: "Gris",
  },
  {
    value: "6",
    label: "Naranja",
  },
  {
    value: "7",
    label: "Negro",
  },
  {
    value: "8",
    label: "Rojo",
  },
  {
    value: "9",
    label: "Turquesa",
  },
  {
    value: "10",
    label: "Verde",
  },
];

export const ACTIVE_SORTERS = [
  "startDate",
  "engineType",
  "snStand",
  "esnEnter",
  "colour",
  "phase",
];

export const CLOSED_SORTERS = [
  "startDate",
  "endDate",
  "engineType",
  "snStand",
  "esnExit",
  "colour",
];

export default selectsLists;
